<template>
  <div
    :class="[
      'home-banner',
      `home-banner-${country}`,
      { 'placeholder-padding': !sliderList.length },
      { 'custom-home-banner': citySliderList },
      `${sliderStyle}`,
      `${page_style || ''}`,
      `${positionStyle}`,
      `${formItem.page}`,
    ]"
    v-if="apiFlag ? sliderList.length : true"
  >
    <div v-if="sliderTipButton" class="manual" @click="openManual">
      <i class="icon icon-v3_outlined_move" />
      {{ sliderTipButton.title }}
    </div>
    <swiper :class="sliderStyle" v-if="sliderList.length">
      <swiper-slider v-for="(item, idx) in sliderList" :key="idx">
        <div
          v-if="citySliderList"
          @click="goCustomLink(item)"
          :class="['custom-banner-item', 'h5_br', `${formItem.page}`]"
          :style="{
            background: `url(${getWebpImg(
              item.background_img_url
            )}) center top / 100% no-repeat`,
          }"
        >
          <div class="banner-item-title">
            <img
              :src="
                item.title_icon ||
                'https://s3-us01.didiglobal.com/silver-bullet-img/2024-09-09/Nez59J/icon_reward_42_3x.png'
              "
              alt=""
            />
            <span>{{ item.title }}</span>
          </div>
          <div class="banner-item-subtitle-wrapper">
            <div class="banner-item-subtitle" v-html="getSubTitle(item)"></div>
            <img
              v-if="item.link.type === 'download_url' ? !ends.isDriverApp : item.link"
              src="https://s3-us01.didiglobal.com/silver-bullet-img/2024-09-09/5rH4-8/arrow_24_3x.png"
              alt=""
            />
          </div>

          <!-- v-if="item.count_down" -->
          <timer-countdown
            :deadline="item.count_down"
            :ignoreDay="false"
            v-slot="time"
            class="timer-countdown"
            v-if="item.count_down"
          >
            <!-- <span>{{transTo2(time.day)}}d</span>
            <span>{{transTo2(time.hour)}}时</span>
            <span>{{transTo2(time.minute)}}分</span>
            <span>{{transTo2(time.second)}}秒</span> -->
            <span>{{ time.day }}d</span>:<span>{{ time.hour }}</span
            >:<span>{{ time.minute }}</span
            >:<span>{{ time.second }}</span>
          </timer-countdown>
        </div>
        <div
          v-else
          :class="['banner-item', 'h5_br', 'h5_funnel']"
          @click="goLink(item)"
          :style="{
            background: `url(${getWebpImg(
              item.background_img_url
            )}) center top / 100% no-repeat`,
          }"
        >
          <div
            class="banner-item-title"
            :style="{
              color: item.text_color,
            }"
          >
            {{ item.title }}
          </div>
          <div
            class="banner-item-subTitle"
            :style="{
              color: item.text_color,
            }"
          >
            {{ item.sub_title }}
          </div>
        </div>
      </swiper-slider>
    </swiper>
    <page-pop
      class="custom-page-pop"
      ref="pagepop"
      :title="customPageTitle || $t('GDriver_Rwards_EXVw_LGRt')"
    >
      <iframe :src="customJumpLink" frameborder="0"></iframe>
    </page-pop>
  </div>
</template>
<script>
import { mapMutations, mapState } from "vuex";
import TimerCountdown from "./time-countdown/index.vue";
import PagePop from "./pop-dialog/index.vue";
import { post } from "../../tools/request";
import { ends } from "../../tools/constant";
import { Swiper, SwiperSlider } from "./Swiper";
import { goThirdLink } from "../../tools/utils";
import { getImageResizeUrl } from "@didi/webcube";

export default {
  props: ["formItem", "omegaItem", "page_style", "position_style", "hasCityInfo"],
  components: {
    Swiper,
    SwiperSlider,
    TimerCountdown,
    PagePop,
  },
  data() {
    return {
      ends,
      citySliderList: null,
      apiFlag: false,
      reqSequence: false,
      customApi: {
        new_driver_reward: `${process.env.BASE_URL}/gulfstream/deadpool/api/getNewDriverRewardInfo`,
      },
      customJumpLink: "",
      customPageTitle: "",
      regularPage: ['audit_page', 'result_page_checking', 'result_page_success', 'result_page']
    };
  },
  mounted() {
    // // console.log(this.formItem)
    if (this.regularPage.includes(this.formItem.page)) {
      this.getBannerList();
      // 先不延时了
      // setTimeout(() => {
      //   this.getBannerList();
      // }, 2000)
    } 
  },
  watch: {
    _area: {
      handler(newV, oldV) {
        if (this.hasCityInfo && !newV.value) return
        if ((newV.value || !this.apiFlag) && this.formItem.api_type && !this.regularPage.includes(this.formItem.page)) {
          this.getBannerList();
        }
      },
      deep: true,
      immediate: true, //页面初始化时立即调用
    },
  },
  computed: {
    ...mapState(["_area", "_ticket"]),
    country() {
      const up = new URLSearchParams(location.search);
      return up.get("location_country");
    },
    sliderList() {
      console.log("sliderList", this.citySliderList || this.formItem.img || []);
      return this.apiFlag && !this.citySliderList
        ? this.formItem.img || []
        : this.citySliderList || [];
    },
    sliderStyle() {
      return this.formItem.style || "h5_br";
    },
    positionStyle() {
      return this.position_style || "";
    },
    sliderTipButton() {
      return this.formItem.tip_button || null;
    },
    getSubTitle() {
      return (item) => {
        // <img src="https://s3-us01.didiglobal.com/silver-bullet-img/2024-09-09/5rH4-8/arrow_24_3x.png" alt="" />
        return (item.sub_title || item.content).replace(
          /\{\{total_reward\}\}/,
          `<span class="bold">${item.total_reward}</span>`
        );
      };
    },
  },
  methods: {
    transTo2(num) {
      if (num > 9) {
        return num;
      }
      return `0${num}`;
    },
    openManual() {
      // 埋点上报
      Omega.trackEvent("sailing_d_x_landingpage_handbook_ck", "");
      setTimeout(() => {
        // 跳转
        location.href = this.sliderTipButton.link;
      }, 100);
    },
    getWebpImg(url) {
      // console.log('getWebpImg', getImageResizeUrl(url, true))
      return getImageResizeUrl(url, true);
    },
    goLink(item) {
      Omega.trackEvent(
        "ibt_onboarding_landingpageclickbanner_ck",
        "",
        this.omegaItem
      );
      if (!item.link) {
        return;
      }

      let up = new URLSearchParams(location.search);
      if (this._area.value && this._area.text) {
        up.set("areaId", this._area.value);
        up.set("areaName", this._area.text);
      }
      goThirdLink({
        up,
        url: item.link,
        target: item.link_type || item.target,
      });
    },
    getBannerList() {
      let up = new URLSearchParams(location.search);
      up.set("area_id", this._area.value || "");
      up.set("page", this.formItem.page);
      if (this._ticket) {
        up.set("ticket", this._ticket);
      }
      const customInfoApi = this.customApi[this.formItem.api_type] || "";
      post(customInfoApi, up)
        .then((res) => {
          // res = {}
          console.log("33333333333", res);
          if (res && !Array.isArray(res) && JSON.stringify(res) !== "{}") {
            // this.citySliderList = [
            //   {
            //     page: "landing_page",
            //     background_img_url:
            //       "https://img0.didiglobal.com/static/driver_xml_image/40d2d421/banner_bg_ob_99%402x.png",
            //     title: "NEWPEOPLE",
            //     sub_title: "Complete registration & get up to {{total_reward}}",
            //     link: "www.baidu.com",
            //     count_down: "300",
            //     total_reward: "10",
            //     banner_type: "new_driver_reward",
            //   },
            // ];
            const res_copy = JSON.parse(JSON.stringify(res))
            this.citySliderList = [res_copy];
            // this.$set(this.citySliderList, 0, res);
            console.log("1111111", this.citySliderList, res);
            
            if (this.formItem.api_type === 'new_driver_reward') {
              this.drvCampOmega('ibt_onboarding_drv_camp_banner_sw', res)
            }
          } else if (
            res &&
            Array.isArray(res) &&
            JSON.stringify(res) !== "[]"
          ) {
            this.citySliderList = res;
          } else {
            this.citySliderList= null;
          }
          console.log(res);
          
        })
        .catch((res) => {})
        .finally((res) => {
          this.apiFlag = true;
        });
    },
    goDownload(item) {
      if (ends.isDriverApp) {
        return;
      }
      let { ios, android } = this.formItem.to;
      if (!!Fusion.openPage && !ends.isDriverApp) {
        Fusion.openPage && Fusion.openPage({
          url: ends.isIOS ? ios : android,
          target: "native",
          browser: true
        });
        return;
      }
      
      if (ends.isPC) {
        window.open(android, "_blank");
      } else if (ends.isIOS) {
        window.open(ios, "_blank");
      } else if (ends.isAndroid) {
        window.open(android, "_blank");
      } else {
        window.open(android, "_blank");
      }
    },
    goCustomLink(item) {
      if (!item.link) return
      this.drvCampOmega('ibt_onboarding_drv_camp_banner_ck', item)
      if (item.link.type === 'download_url') {
        this.goDownload(item)
      } else {
        console.log("this.$refs.cookiepop", this.$refs.pagepop);
        this.customPageTitle = item.page_title;
        this.$refs.pagepop.popShow = true;
        let up = new URLSearchParams(location.search);
        if (this._ticket) {
          up.set("ticket", this._ticket);
        }
        const params = new URLSearchParams({
          page: this.formItem.page,
          product_category: item.product_category || '',
          city_id: item.city_id || ''
        });
        this.customJumpLink = `${item?.link?.url}?${params.toString()}&${up.toString()}`;
      }
      
      // this.drvCampOmega('ibt_onboarding_drv_camp_rule_sw', item)
    },
    // 新人营埋点
    drvCampOmega(key, data) {
      let up = new URLSearchParams(location.search);
      let omegaItem = {
        campaign_id: data.campaign_id,
        driver_id: data.driver_id,
        ticket: this._ticket || up.get("ticket"),
        status: data.is_binded ? 1 : 0,
        page: this.formItem.page
      }
      try {
        Omega.trackEvent(key, "", {
          ...omegaItem,
        });
      } catch (error) {}
    }
  },
};
</script>
<style lang="scss" scoped>
.home-banner {
  margin-bottom: 0.4rem;
  background: transparent;
  &.h5_funnel {
    margin-bottom: 0.64rem;
  }
  &.landing_page {
    .banner-item.h5_funnel {
      height: 5rem;
    }
  }
  &.placeholder-padding {
    height: 2.6rem;
    &.landing_page {
      height: 5rem;
    }
  }
  &.custom-home-banner {
    margin-bottom: 0.4rem;
    // margin-bottom: 400px;
    .banner-item-title {
      width: 72%;
    }
    .banner-item-subtitle-wrapper {
      width: 75%;
    }
    &.landing_page {
      height: 5rem;
      margin-bottom: 0;

      .banner-item-subtitle {
        ::v-deep .bold {
          font-size: 0.64rem;
          line-height: 0.68rem;
          font-weight: 700;
          position: relative;
          background: linear-gradient(
            to top,
            transparent 0%,
            transparent 9%,
            #f4ba98 10%,
            #f4ba98 35%,
            transparent 36%,
            transparent 100%
          );
        }
      }
    }
    &.result_page,
    &.result_page_checking,
    &.result_page_success {
      height: 2rem;
      margin-top: 0;
      .banner-item-subtitle-wrapper {
        width: 60%;
      }
    }
    
  }

  .manual {
    position: absolute;
    z-index: 10;
    box-sizing: border-box;
    width: auto;
    max-width: 3rem;
    height: 0.56rem;
    padding: 0 0.24rem;
    display: flex;
    align-items: center;
    border: 1px solid #ffffff;
    border-radius: 0.32rem;
    // font-family: "DiDiSans-Pro-Medium";
    font-size: 0.28rem;
    color: #ffffff;
    letter-spacing: 0;
    line-height: 0.56rem;
    font-weight: 500;
    margin: 0.32rem 0 0 0.32rem;
    .icon {
      font-size: 0.32rem;
      margin-right: 0.08rem;
    }
  }
  .banner-item {
    &.lapping {
      padding: 0.64rem;
      color: #fff;
    }
    &.h5_funnel {
      height: 2.6rem;
      padding: 0.32rem;
      .banner-item-title {
        margin-bottom: 0.06rem;
        font-size: 0.36rem;
        font-weight: 700;
        line-height: 0.44rem;
      }
      .banner-item-subTitle {
        font-size: 0.24rem;
        font-weight: 400;
        line-height: 0.3rem;
      }
      .banner-item-title,
      .banner-item-subTitle {
        width: 67%;
        color: #333333;
      }
    }

    height: 5rem;
    padding-left: 0.48rem;
    padding-top: 0.84rem;
    box-sizing: border-box;
    color: #fff;
    text-align: center;
    .banner-item-title,
    .banner-item-subTitle {
      width: 50%;
      text-align: left;
    }
    .banner-item-bg {
      position: relative;
      width: 100%;
    }
    .banner-item-logo {
      margin: 0 auto 0.48rem;
      max-width: 0.82rem;
      max-height: 0.82rem;
    }
    .banner-item-title {
      margin-bottom: 0.48rem;
      font-size: 0.44rem;
      font-weight: 700;
    }
    .banner-item-subTitle {
      margin-bottom: 0.48rem;
      font-size: 0.32rem;
      line-height: 1.2;
    }
  }
  .custom-banner-item {
    height: 2.6rem;
    padding-left: 0.32rem;
    padding-top: 0.56rem;
    box-sizing: border-box;
    &:not(.landing_page) {
      padding-top: 0;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
    .banner-item-title {
      margin-bottom: 0.12rem;
      font-size: 0.28rem;
      line-height: 0.28rem;
      font-weight: 700;
      color: #ff8040;
      > img {
        width: 0.42rem;
        height: 0.42rem;
        margin-right: 0.1rem;
        vertical-align: middle;
      }
    }
    .banner-item-subtitle-wrapper {
      line-height: 0;
      font-size: 0;
      img {
        width: 0.24rem;
        height: 0.24rem;
      }
    }
    .banner-item-subtitle {
      display: inline;
      font-size: 0.36rem;
      color: #333333;
      line-height: 0.48rem;
      font-weight: 500;
      ::v-deep * {
        display: inline !important;
      }
      ::v-deep .bold {
        font-size: 0.4rem;
        line-height: 0.48rem;
        font-weight: 700;
        position: relative;
        background: linear-gradient(
          to top,
          transparent 0%,
          transparent 9%,
          #f4ba98 10%,
          #f4ba98 35%,
          transparent 36%,
          transparent 100%
        );
      }
      // ::v-deep img {
      //   width: 0.24rem;
      //   height: 0.24rem;
      // }
    }
    .timer-countdown {
      display: block;
      margin-top: 0.12rem;
      font-size: 0.28rem;
      color: #ff8040;
      > span {
        display: inline-block;
        // width: 0.4rem;
        height: 0.4rem;
        box-sizing: border-box;
        padding: 0 0.035rem;
        margin: 0 0.08rem;
        background: rgba(255, 128, 64, 0.2);
        border-radius: 0.08rem;
        color: #ff8040;
        font-size: 0.28rem;
        line-height: 0.4rem;
        font-weight: 700;
        &:first-child {
          margin-left: 0;
        }
      }
    }
    &.landing_page {
      height: 5rem;
      .banner-item-subtitle-wrapper{
        width: 60%;
      }
      .banner-item-subtitle {
        ::v-deep .bold {
          line-height: 0.68rem;
        }
      }
    }
    &.result_page,
    &.result_page_checking,
    &.result_page_success {
      height: 2rem;
      margin-top: 0;
      // padding-top: 0.34rem;
      border-radius: 0.16rem;
      .banner-item-subtitle {
        font-size: 0.32rem;
        line-height: 0.32rem;
        ::v-deep .bold {
          font-size: 0.32rem;
          line-height: 0.32rem;
        }
      }
    }
  }
  .custom-page-pop {
    ::v-deep iframe {
      width: 100%;
      height: 100%;
    }
  }
}
.home-banner-BR {
  .custom-banner-item {
    .banner-item-title {
      color: #333333;
    }

    .banner-item-subtitle {
      ::v-deep .bold {
        line-height: 0.68rem;
        background: linear-gradient(
          to top,
          transparent 0%,
          transparent 9%,
          #ffdd00 10%,
          #ffdd00 35%,
          transparent 36%,
          transparent 100%
        );
      }
    }
    .timer-countdown {
      color: #333333;
      > span {
        color: #333333;
        background: rgba(255, 221, 0, 0.6);
      }
    }
  }
}
</style>
